import { HAKLAI_PTOR_TYPES } from "../calc/shared/haklaiConstants";

const FULL_EXEMPTION_TYPES = new Set([
  HAKLAI_PTOR_TYPES.SINGLE,
  HAKLAI_PTOR_TYPES.INHERITANCE
]);

export function isHaklaiAnalysisFullyExempt(analyzedPreCalc) {
  const parts = Array.isArray(analyzedPreCalc?.preCalcPartsData)
    ? analyzedPreCalc.preCalcPartsData
    : [];
  if (parts.length === 0) return false;

  const seenPropertyKeys = new Set();

  return parts.every((part) => {
    const propertyKey = part?.haklaiPropertyKey;
    if (
      typeof propertyKey !== "string"
      || !propertyKey.trim()
      || propertyKey.trim() !== propertyKey
      || seenPropertyKeys.has(propertyKey)
    ) {
      return false;
    }
    seenPropertyKeys.add(propertyKey);

    if (!FULL_EXEMPTION_TYPES.has(part?.haklaiPtorType)) return false;

    const routeFlags = [part?.needsMutav, part?.needsRegTax];
    if (routeFlags.some((flag) => flag !== undefined && typeof flag !== "boolean")) {
      return false;
    }

    return !routeFlags.some((flag) => flag === true);
  });
}
